<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load()" />
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="far fa-building fa-fw"
                            type="select"
                            placeholder="Todas"
                            :optionsList="$util.unidades_com_tags(false, true)"
                            optionsData="id_unidade_operacao"
                            v-model="filtros.id_unidade_operacao" />
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fas fa-funnel-dollar fa-fw"
                            type="select"
                            placeholder="Todos os Centros de Custo..."
                            :optionsList="lista_centro_custo"
                            optionsData="id_centro_custo"
                            v-model="filtros.id_centro_custo" />
                    </div>

                </div>

                <div class="form-row mt-2">

                    <div class="col col-12 col-md-6">
                        <az-input
                            icon="fa fa-search"
                            v-model="filtros.search"
                            @onEnter="load()">
                            <template v-slot:buttonposb>
                                <print-export printid="lista-impressao" />
                            </template>
                        </az-input>
                    </div>

                    <div class="col col-12" :class="block_local ? 'col-md-6' : 'col-md-3'">
                        <az-input
                            type="select"
                            icon="fa fa-filter"
                            placeholder="Todos..."
                            optionsMode="json"
                            :optionsList="[
                                { id: 'A', search: 'A Confirmar' },
                                { id: 'X', search: 'Confirmado' },
                                { id: 'R', search: 'Recebido' },
                                { id: 'N', search: 'Não Recebido' },
                            ]" 
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="filtros.status" />
                    </div>

                    <div class="col col-12 col-md-3" v-if="!block_local">
                        <az-input
                            icon="fas fa-warehouse"
                            placeholder="Selecione o Local..."
                            type="select"
                            service="estoque_locals.index"
                            optionsData="id_estoque_local"
                            optionsMode="aql"
                            optionsName="estoque_locals.index.sup"
                            :optionsParm="{ sup: 1 }"
                            v-model="filtros.id_estoque_local" />
                    </div>

                </div>

            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state 
                v-if="!lista || !lista.length"
                :icon="firstLoad ? 'fas fa-clipboard-check' : 'fas fa-sync-alt'" 
                :msg="firstLoad ? 'Nenhum item para recebimento encontrado.' : 'Clique no ícone para atualizar a busca.'"
                :action="firstLoad ? '' : 'Buscar'"
                :method="load"></az-empty-state>

        <div id="lista-impressao" v-else>

            <cabecalho-generico titulo="Atendimentos">
                <div v-if="filtros_busca">
                    <div>{{ $util.filtro_2_periodo(filtros_busca) }}</div>
                    <div v-if="filtros.search">Pesquisa: {{ filtros.search }}</div>
                </div>
            </cabecalho-generico>

            <div class="small text-muted">
                <small v-if="dados && dados.last_page > 1">
                    {{ dados.from }} - {{ dados.to }}  / {{ dados.total }} 
                </small>
                <small v-else>
                    {{ dados.data.length }} 
                </small>
            </div>

            <div class="card carde mb-2 w3-animate-opacity" v-for="(mov, inx) in lista" :key="inx">
                <div class="card-body py-2">
                    <div class="row" >
                        <div class="col col-12 col-md-2">
                            <a href="#" @click.prevent="filtrar('#' + mov.link.model.id_estoque_solicitacao)" class="card-link">
                                #{{ mov.link.model.id_estoque_solicitacao }}
                            </a>
                            <div class="small">
                                {{ $util.getFormatDate(mov.dt_movimentacao) }}
                                {{ mov.dt_movimentacao.substr(11,5) }}
                            </div>
                        </div>
                        <div class="col col-12 col-md-6">
                            <div v-if="mov.link.model.solicitacao.fl_paciente && mov.link.model.solicitacao.marcacao">
                                <i class="fa fa-user mr-2" aria-hidden="true"></i>
                                <span class="small">
                                    {{ mov.link.model.solicitacao.marcacao.nome_paciente }}
                                    <span v-if="mov.link.model.solicitacao.marcacao.id_atendimento" class="ml-2">
                                        #{{ mov.link.model.solicitacao.marcacao.id_atendimento }}
                                    </span>
                                </span>
                            </div>
                            <div>
                                <template v-if="mov.id_estoque_tipo_movimentacao == 4">
                                    Transferência 
                                </template>
                                <template v-else-if="mov.link.model.solicitacao.centro_custo">
                                    <a href="#" @click.prevent="filtrar(mov.link.model.solicitacao.centro_custo.search)" class="card-link">
                                        {{ mov.link.model.solicitacao.centro_custo.search }}
                                    </a>
                                    <span class="badge badge-light mx-1" v-if="mov.link.model.solicitacao.centro_custo.unidade_operacao && mov.link.model.solicitacao.centro_custo.unidade_operacao.st_sigla">
                                        {{ mov.link.model.solicitacao.centro_custo.unidade_operacao.st_sigla }}
                                    </span>
                                </template>
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                <a href="#" @click.prevent="filtrar(mov.usuario.search)" class="card-link">
                                    {{ mov.usuario.search }}
                                </a>
                            </div>
                            <div>
                                {{ mov.item.search }} (#{{ mov.id_estoque_item }})
                                <template v-if="mov.st_lote && mov.st_lote != 'Sem Lote'">
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    <span class="small">
                                        Lote: {{ mov.st_lote }}
                                    </span>
                                </template>
                            </div>
                            <div class="small text-muted" v-if="mov.complemento">
                                {{ mov.complemento }}
                            </div>
                        </div>
                        <div class="col col-12 col-md-2">
                            {{ mov.in_quantidade }} 
                            <small class="text-muted">{{ mov.item.st_unidade_estoque }}</small>

                            <a href="#" @click.prevent="ver_composicao(mov)" class="card-link" title="Ver Composição" v-if="mov.item.fl_kit_transform">
                                <i class="fas fa-box ml-2"></i>
                            </a>
                            
                            <div class="small text-muted" v-if="1 == 1 || mov.in_quantidade != mov.link.model.in_quantidade">
                                <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Quantidade solicitada"></i>
                                {{ mov.link.model.in_quantidade }}
                            </div>
                        </div>
                        <div class="col col-12 col-md-2">
                            <div v-if="mov.dt_confirm_receb">
                                <i class="fa fa-check-circle fa-2x text-success" aria-hidden="true" v-if="mov.fl_recebido"></i>
                                <i class="fa fa-times-circle fa-2x text-danger" aria-hidden="true" v-else></i>
                                <div class="small text-muted">
                                    <a href="#" @click.prevent="$util.logAudit('estoqueMovimentacao', mov.id_estoque_movimentacao)" class="card-link">
                                        {{ $util.getFormatDate(mov.dt_confirm_receb) + ' ' + mov.dt_confirm_receb.substr(11,5) }}
                                    </a>
                                </div>
                                <div class="small text-muted" v-if="mov.usuario_receb">
                                    {{ mov.usuario_receb.search }}
                                </div>
                                <div v-if="mov.st_observacao" class="small text-muted">
                                    {{ mov.st_observacao }}
                                </div>
                                <div v-if="( mov.fl_recebido === 0 || mov.fl_recebido === false ) && mov.in_quantidade > 0 && mov.id_estoque_tipo_movimentacao == 2 && mov.in_fator_saldo < 0">
                                    <a href="#" @click.prevent="cancelar_mov_nao_receb(mov)" class="small">
                                        Cancelar Movimentação
                                    </a>
                                </div>
                            </div>
                            <template v-else>
                                <az-input
                                    sizing="sm"
                                    type="button-group"
                                    :optionsList="[
                                        { id: true, search: 'Sim' },
                                        { id: false, search: 'Não' },
                                        { id: 'P', search: 'Pendente' },
                                    ]"
                                    v-model="mov.selecionado" />

                                <!--
                                <input type="checkbox" class="form form-control" v-model="mov.selecionado">
                                -->
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <br><br><br><br><br>

            <nav class="navbar fixed-bottom navbar-light bg-light" id="menu-guias" v-if="dados && tem_pra_confirmar">
                <div class="d-flex">
                    <button class="btn btn-outline-secondary mr-2" type="button" @click="marcar_todos(true)">
                        <i class="far fa-check-square d-block d-lg-none"></i>
                        <span class="d-none d-lg-block">
                            Marcar Todos
                        </span>
                    </button>
                    <button class="btn btn-outline-secondary mr-2" @click="marcar_todos(false)">
                        <i class="far fa-square d-block d-lg-none"></i>
                        <span class="d-none d-lg-block">
                            Desmarcar Todos
                        </span>
                    </button>
                    <button class="btn btn-outline-secondary mr-2" @click="marcar_todos('P')">
                        <i class="fa-solid fa-pause d-block d-lg-none"></i>
                        <span class="d-none d-lg-block">
                            Todos Pendentes
                        </span>
                    </button>
                    <span class="ml-2" v-if="dados.data">

                        <!-- Paginação -->
                        <div v-if="dados && ( dados.last_page > 1 || ( !dados.last_page && dados.to >= dados.per_page ) )">
                            <paginate
                                class="mb-0"
                                :page-count="dados.last_page ? dados.last_page : ( dados.current_page + 1 )"
                                :container-class="'pagination'"
                                :page-class="'page-item'"
                                :page-link-class="'page-link'"
                                :prev-class="'page-link'"
                                :next-class="'page-link'"
                                :prev-text="'<<'"
                                :next-text="'>>'"
                                :click-handler="paginar">
                            </paginate>
                        </div>

                    </span>
                </div>
                <div>
                    <div class="progress mt-0 mb-1">
                        <div class="indeterminate" v-if="$store.state.loading"></div>
                        <div class="determinate" v-else></div>
                    </div>

                    <button class="btn btn-success" @click="confirmar()">
                        Confirmar Recebimento
                    </button>
                </div>
            </nav>

        </div>

        <!-- Modal -->
        <div class="modal fade" id="confirmUsuarioModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" :class="info_solic ? 'modal-xl' : ''" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Confirmar Usuário Recebedor</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <input 
                                    placeholder="Login..."
                                    type="text" 
                                    v-model="filtros.login" 
                                    autocomplete="off"
                                    class="form form-control" />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col col-12">
                                <input 
                                    placeholder="Senha..."
                                    type="text" 
                                    id="password" 
                                    style="-webkit-text-security: disc;" 
                                    v-model="filtros.senha" 
                                    autocomplete="off"
                                    class="form form-control" />
                            </div>
                        </div>

                        <!-- Campos Customizados -->
                        <div v-if="info_solic && info_solic.campos_customizados" class="row mt-3">
                            <div class="col col-12">
                                <az-sub-title :title="info_solic.campos_customizados.st_titulo" />
                                <formulario
                                    :gutters="true"
                                    :validate="validate"
                                    v-model="info_solic.campos_customizados.js_campos"
                                    :saved="true"
                                    mode="fixed"
                                    :config="true" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">Confirmar</az-submit>
                    </div>
                </div>
            </div>
        </div>


        <composicao-transformacao ref="comp" @refresh="load" />
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import PrintExport from '../../shared/PrintExport.vue';
import Formulario from '../consultorio/Formulario.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import ComposicaoTransformacao from './ComposicaoTransformacao.vue';

export default {
    data () { 
        return { 
            dados: null, 
            filtros: { 
                status: "A",
                id_estoque_local: this.$util.getCookie('estoque-armazem'), 
                inicio: "",
                fim: "", 
                semana: "",
                mes: "",
                periodo: "s",
                referencia: "", 
                search: "", 
                login: "", 
                senha: "", 
                id_unidade_operacao: this.$util.getCookie('id_unidade_operacao'), 
                id_centro_custo: "", 
            },
            filtros_busca: null, 
            firstLoad: false, 
            block_local: false, 
            info_solic: null, 
            validate: false, 
            page: 1, 
        }
    },

    components: { 
        AzEmptyState,
        AzInput,
        AzPeriodo,
        AzSubmit, 
        CabecalhoGenerico, 
        PrintExport, 
        Formulario, 
        AzSubTitle, 
        ComposicaoTransformacao, 
    },

    computed: { 
        lista: function () { 
            if ( !this.dados || !this.dados.data || !this.dados.data.length )
                return [];

            let reg = this.$util.getregex(this.filtros.search);

            return this.dados.data.filter(item => !this.filtros.search || reg.test(JSON.stringify(item)));
        },

        lista_centro_custo: function () { 
            if ( !this.filtros.id_unidade_operacao )
                return [];

            let unidade = this.$store.state.unidade.unidade_operacaos
                .find(item => item.id_unidade_operacao == this.filtros.id_unidade_operacao);

            if ( unidade )
                return unidade.centro_custos;

            return [];
        },

        tem_pra_confirmar: function () { 
            return ( this.lista && this.lista.find(mov => !mov.dt_confirm_receb) ) ? true : false; 
        },
    },

    methods: { 
        paginar (page) { 
            this.page = page;
            this.load();
        },
        ver_composicao (mov) { 
            this.$refs.comp.abrir(mov);
        },

        cancelar_mov_nao_receb (mov) { 
            if ( !confirm("Confirma cancelar a movimentação da solicitação #" + mov.link.model.id_estoque_solicitacao + " do item '" + mov.item.search + "'?") ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'estoque', 
                func: 'cancelar_mov', 
                dados: { 
                    lista: [
                        { 
                            id_estoque_movimentacao: mov.id_estoque_movimentacao
                        }
                    ], 
                }, 
                toast: true, 
                reload: true, 
            });
        },

        filtrar (info) { 
            if ( info )
                info = '"' + info + '"';
            
            this.filtros.search = ( this.filtros.search == info ? '' : info );
        },

        load() { 
            this.filtros_busca = _.cloneDeep(this.filtros);

            this.$util.load(this, { 
                service: 'estoque',
                func: 'confirm_recebimento', 
                parms: { 
                    ...this.filtros, 
                    paginado: true, 
                    page: this.page,
                },
                page: this.page, 
                loadTo: res => { 
                    res.data.forEach(item => { 
                        item.selecionado = null;
                    });

                    this.dados = res;

                    if ( this.dados.last_page < this.page && this.page > 1 ) { 
                        this.page = 1;
                    } else if ( !this.dados.last_page && this.dados.current_page > 1 && !this.dados.from && !this.dados.to ) { 
                        this.page = 1;
                    }
                }
            });

            this.firstLoad = true;

            this.$util.setCookie('id_unidade_operacao', this.filtros.id_unidade_operacao);
        },

        marcar_todos(acao) { 
            this.dados.data.forEach(item => {
                item.selecionado = acao;
            });
        },

        confirmar () { 
            this.info_solic = null;
            this.filtros.login = "";
            this.filtros.senha = "";

            let solics = _.uniq(this.lista.map(mov => _.get(mov, 'link.model.id_estoque_solicitacao')));

            if ( solics.length == 1 ) { 

                this.$util.load(this, { 
                    service: 'estoque_solicitacoes',
                    func: 'show',
                    parms: { 
                        id: _.first(solics),
                        atendimento: true, 
                    },
                    loadTo: res => { 
                        if ( res.campos_customizados && res.campos_customizados.js_campos && res.campos_customizados.js_campos.length > 0 ) { 
                            this.info_solic = res;
                        }

                        $('#confirmUsuarioModal').modal('show');
                    },
                });

            } else { 

                $('#confirmUsuarioModal').modal('show');

            }
        },

        atualizar() { 
            if ( !this.filtros.login || !this.filtros.senha ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Realize a identificação do usuário recebedor.",
                    life: 3000
                });
                return;
            }

            this.$util.atualizar(this, { 
                service: 'estoque',
                func: 'confirm_receb_atualizar',
                dados: { 
                    lista: this.lista.filter(item => !item.dt_confirm_receb), 
                    login: this.filtros.login, 
                    senha: this.filtros.senha, 
                    info_solic: this.info_solic,
                },
                modal: 'confirmUsuarioModal',
                reload: true, 
            })
        }
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "Suprimentos", path: "/suprimentos" },
            { name: 'Confirmar Recebimento', path: "/suprimentos/recebimento" }
        ]);

        this.$util.loadItem(this, { 
            service: 'configuracoes', 
            func: 'index', 
            parms: { 
                where: { 
                    st_slug: 'confirm-receb-nao-filtro-local', 
                    st_valor: 1
                }
            }
        })
        .then(res => { 
            if ( res.length > 0 ) { 
                this.filtros.id_estoque_local = "";
                this.block_local = true; 
            }
        });
    }
}
</script>